import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import {
  STORAGE_ACCOUNT_SWITCH_CLEANUP_KEYS,
  STORAGE_EXCEPTIONAL_KEY_REGEX,
  STORAGE_LOGOUT_CLEANUP_KEYS,
  STORAGE_PREFIX,
  StorageService
} from './storage.service';

@NgModule({
  imports: [CommonModule],
  providers: [StorageService]
})
export class StorageModule {
  public static forChild(
    prefix: string,
    cleanupKeysOnLogout?: string[] | true,
    cleanupKeysOnAccountSwitch?: string[] | true,
    exceptionalKeyPattern?: RegExp
  ): ModuleWithProviders<StorageModule> {
    return {
      ngModule: StorageModule,
      providers: [
        StorageService,
        {
          provide: STORAGE_PREFIX,
          useValue: prefix
        },
        {
          provide: STORAGE_LOGOUT_CLEANUP_KEYS,
          useValue: cleanupKeysOnLogout
        },
        {
          provide: STORAGE_ACCOUNT_SWITCH_CLEANUP_KEYS,
          useValue: cleanupKeysOnAccountSwitch
        },
        {
          provide: STORAGE_EXCEPTIONAL_KEY_REGEX,
          useValue: exceptionalKeyPattern
        }
      ]
    };
  }
}

export * from './storage.service';
